export const ONBOARD_PATH = '/administration/pending-hires/onboard';
export const REHIRE_PATH = '/administration/pending-hires/rehire';
export const ATS_ONBOARD_PATH = '/administration/pending-hires/ats-onboard';
export const PENDING_HIRES_URL = `/administration/pending-hires`;
export const PLATFORM_SETTINGS_URL = '/administration/platform-settings';
export const WORKFLOWS_PATH = '/administration/workflows';
export const PROFILE_TEMPLATE_PATH = '/administration/profile-setup/profile-templates';
export const PLATFORM_SETTING_PATH = '/administration/profile-setup/all-job-details';
